import React from 'react'
import TabContent from "./TabContent";
import TabControl from "./TabControl";

const ContentTabs = ({data}) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    const [activeIndex, setActiveIndex] = React.useState(null);
    const breakpoint = 768; // The width below which the mobile view should be rendered
    
    const contentToShow = activeIndex !== null ? 
        data[activeIndex]
        : data[0];
    
    const showTabControl = data.length > 1;

    //Detect change in screen width
    React.useEffect(() => {
        window.addEventListener("resize", setWidthToInnerWidth);
        
        //remove event listener on unmount.
        return () => {
            window.removeEventListener("resize", setWidthToInnerWidth);
        }
    }, []);
    
    function setWidthToInnerWidth (){
        setWidth(window.innerWidth)
    }
    
    function onTabControlClick (index){
        if (activeIndex === index){
            setActiveIndex(null);
        }
        else {
            setActiveIndex(index);
        }
    }
    
    return (
        <div className="contentTabs">
            {
                width > breakpoint ?
                    <TabContent isActive={true}
                                backgroundUrl={contentToShow.backgroundUrl}
                                iconUrl={contentToShow.iconUrl}
                                title={contentToShow.title}
                                subTitle={contentToShow.subTitle}
                                mainText={contentToShow.mainText}
                                mainText2={contentToShow.mainText2}
                                buttonText={contentToShow.buttonText}
                                buttonUrl={contentToShow.buttonUrl} />
                : null
            }
            <div className="tabControl">
                {
                    data.map((control, index) => (
                        <React.Fragment key={index}>
                            {showTabControl ?
                                <TabControl index={index}
                                            isActive={index == activeIndex || (activeIndex === null && control == data[0] && width > breakpoint)}
                                            iconUrl={control.tabIconUrl}
                                            title={control.title}
                                            onClick={onTabControlClick} />
                                : null
                            }
                            {width <= breakpoint && (index == activeIndex || !showTabControl) ?
                                <TabContent isActive={true}
                                            backgroundUrl={contentToShow.backgroundUrl}
                                            iconUrl={contentToShow.iconUrl}
                                            title={contentToShow.title}
                                            subTitle={contentToShow.subTitle}
                                            mainText={contentToShow.mainText}
                                            mainText2={contentToShow.mainText2}
                                            buttonText={contentToShow.buttonText}
                                            buttonUrl={contentToShow.buttonUrl} />
                                : null
                            }
                        </React.Fragment>
                    ))
                }
            </div>
        </div>
    )
}

export default ContentTabs;